import * as actionTypes from "./actionTypes";
import {PostType} from '../type.d';
import auth from '../services/authentication';
import Api from '../api/Api';
import { Dispatch } from 'redux';

export function changeFeedbackModalState() {
  return ({
    type: actionTypes.CHANGE_FEEDBACK_MODAL_STATE,
  });
}

export function changeSayThanksModalState() {
  return ({
    type: actionTypes.CHANGE_SAY_THANKS_MODAL_STATE,
  });
}

export function changeWarningModalState() {
  return ({
    type: actionTypes.CHANGE_WARNING_MODAL_STATE,
  });
}

export function changeSuccessModalState() {
  return ({
    type: actionTypes.CHANGE_SUCCESS_MODAL_STATE,
  });
}

export function changeDeleteModalState() {
  return ({
    type: actionTypes.CHANGE_DELETE_MODAL_STATE,
  });
}

export function changeDissconnectModalState() {
  return ({
    type: actionTypes.CHANGE_DISSCONNECT_MODAL_STATE,
  });
}

export function changeAddAccountModalState() {
  return ({
    type: actionTypes.CHANGE_ADD_ACCOUNT_MODAL_STATE,
  });
}

export function testCall() {
  return (dispatch:Dispatch<any> ) => {
    dispatch({type: actionTypes.TEST_STARTED})

    Api.test()
      .then(res => {
        dispatch({
          type: actionTypes.TEST_SUCCESS,
          payload: res
        })
      })
      .catch(err =>{
        dispatch({
          type: actionTypes.TEST_FAILED,
          payload: err
        })
      })
  }
}

export function loginGoogle(data:PostType) {
  return (dispatch:Dispatch<any> ) => {
    dispatch({type: actionTypes.LOGIN_GOOGLE_FETCH})

    Api.loginGoogle(data)
      .then(res => {
        if(res.data){
          auth.setToken(res.data.token);
          dispatch({
            type: actionTypes.LOGIN_GOOGLE_SUCCESS,
            payload: res.data,
          })
        }
        else{
          dispatch({
            type: actionTypes.LOGIN_GOOGLE_FAILED,
            payload: res.data,
          })
        }
      })
      .catch(err =>{
        dispatch({
          type: actionTypes.LOGIN_GOOGLE_FAILED,
          payload: err.response ? err.response.data : err,
        })
      })
  }
}

export function getUserData() {
  return (dispatch: Dispatch<any> ) => {
    dispatch({type: actionTypes.GET_USER_DATA_FETCHED})

    Api.checkSession()
      .then(res => {
        if(res.data.success){
          dispatch({
            type: actionTypes.GET_USER_DATA_SUCCESS,
            payload: res.data,
          })
        }
        else{
          dispatch({
            type: actionTypes.GET_USER_DATA_FAILED,
            payload: res,
          });
        }
      })
      .catch(err => {
        dispatch({
          type: actionTypes.GET_USER_DATA_FAILED,
          payload: err.response,
        })
      })
  }
}

export function getActivityData() {
  return (dispatch: Dispatch<any> ) => {
    dispatch({type: actionTypes.GET_ACTIVITY_DATA_FETCHED})

    Api.activity()
      .then(res => {
        if(res.data.success){
          dispatch({
            type: actionTypes.GET_ACTIVITY_DATA_SUCCESS,
            payload: res.data,
          })
        }
        else{
          dispatch({
            type: actionTypes.GET_ACTIVITY_DATA_FAILED,
            payload: res,
          })
        }
      })
      .catch(err => {
        dispatch({
          type: actionTypes.GET_ACTIVITY_DATA_FAILED,
          payload: err,
        })
      })
  }
}

export function deleteActivity(data:any) {
  return ( dispatch: Dispatch<any> ) => {
    dispatch({type: actionTypes.DELETE_ACTIVITY_FETCHED})

    Api.deleteActivity(data)
      .then(res => {
        if(res.data.success){
          dispatch({
            type: actionTypes.DELETE_ACTIVITY_SUCCESS,
            payload: res.data,
          })
        }
        else{
          dispatch({
            type: actionTypes.DELETE_ACTIVITY_FAILED,
            payload: res,
          })
        }
      })
      .catch(err => {
        dispatch({
          type: actionTypes.DELETE_ACTIVITY_FAILED,
          payload: err,
        })
      })
  }
}